(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aparu-region-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeRegionSelector() {
    const dialog = document.getElementById('AparuRegionDialog');
    const open = document.querySelector('.aparu-region-open');
    if (!dialog || !open || dialog.dataset.initialized) return;
    dialog.dataset.initialized = 'true';
    if (typeof dialog.showModal !== 'function') return;
    const key = 'aparu-region-choice-v1';
    const remember = () => { try { localStorage.setItem(key, 'seen'); } catch (error) {} };
    open.hidden = false;
    open.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
    dialog.querySelector('.aparu-region-close').addEventListener('click', () => { remember(); dialog.close(); });
    dialog.addEventListener('cancel', remember);
    dialog.addEventListener('close', () => open.focus({ preventScroll: true }));
    dialog.querySelector('form').addEventListener('submit', remember);
    let seen = true;
    try { seen = localStorage.getItem(key) === 'seen'; } catch (error) {}
    if (!seen && !window.Shopify?.designMode) dialog.showModal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeRegionSelector, { once: true });
  else initializeRegionSelector();
  document.addEventListener('shopify:section:load', initializeRegionSelector);
  window.addEventListener('pageshow', initializeRegionSelector);
})();
  } catch(e) { console.error(e); }
})();

})();
